import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/base/PageMeta';
import HeroSection from './components/HeroSection';
import AboutPreview from './components/AboutPreview';
import Books2026 from './components/Books2026';
import PublishingFocus from './components/PublishingFocus';
import CatalogEntry from './components/CatalogEntry';
import SonbookRelation from './components/SonbookRelation';
import StoresFaqCTA from './components/StoresFaqCTA';
import { useLocation } from 'react-router-dom';

export default function Home() {
  const location = useLocation();
  const isHomePath = location.pathname === '/home';

  return (
    <div className="min-h-screen bg-background-50">
      <PageMeta
        title="樂律文化｜心理學類書籍出版品牌 LELYRIC"
        description="樂律文化以心理學類書籍為主要出版方向，官方網站提供品牌介紹、最新發行書籍、出版方向說明與崧博書籍資料庫查詢入口。本品牌委託崧博出版經銷，官方網站由崧博出版製作。"
        canonicalPath={isHomePath ? '/' : undefined}
      />
      <Navbar />
      <main>
        <HeroSection />
        <AboutPreview />
        <Books2026 />
        <PublishingFocus />
        <CatalogEntry />
        <SonbookRelation />
        <StoresFaqCTA />
      </main>
      <Footer />
    </div>
  );
}